"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToOrderHistory = exports.subscribeToMarginCancelOrderLiquidationEvents = exports.resetActivePage = exports.requestTradeReports = exports.requestOpenOrdersNextPage = exports.requestOpenOrders = exports.requestInactiveOrders = exports.requestAccountTradesNextPage = exports.requestAccountTrades = exports.removeActiveRequest = exports.receiveTradeReports = exports.receiveTradeHistory = exports.receiveOpenOrdersNextPage = exports.receiveOpenOrders = exports.receiveInactiveOrders = exports.receiveAccountTradesNextPage = exports.receiveAccountTradesForOrderId = exports.receiveAccountTrades = exports.getRecentActivity = exports.getOrders = exports.getOpenTradeReports = exports.getOpenOrders = exports.getInactiveOrders = exports.getAccountTrades = exports.cancelSellOrders = exports.cancelOrders = exports.cancelBuyOrders = exports.cancelAllOrders = exports.addOpenOrder = exports.addInactiveOrder = exports.addAccountTrade = exports.REQUEST_TRADE_REPORTS_NEXT_PAGE = exports.REQUEST_TRADE_REPORTS = exports.REQUEST_RECENT_ACTIVITY = exports.REQUEST_OPEN_ORDERS_NEXT_PAGE = exports.REQUEST_OPEN_ORDERS = exports.REQUEST_INACTIVE_ORDERS_NEXT_PAGE = exports.REQUEST_INACTIVE_ORDERS = exports.REQUEST_ACCOUNT_TRADES_NEXT_PAGE = exports.REQUEST_ACCOUNT_TRADES = exports.REMOVE_ACTIVE_REQUEST = exports.RECEIVE_TRADE_REPORTS_NEXT_PAGE = exports.RECEIVE_TRADE_REPORTS = exports.RECEIVE_TRADE_HISTORY = exports.RECEIVE_RECENT_ACTIVITY = exports.RECEIVE_OPEN_ORDERS_NEXT_PAGE = exports.RECEIVE_OPEN_ORDERS = exports.RECEIVE_INTEREST_ACCRUALS = exports.RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = exports.RECEIVE_INACTIVE_ORDERS = exports.RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = exports.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = exports.RECEIVE_ACCOUNT_TRADES = exports.FetchAccountTradesForOrderId = exports.ADD_OPEN_ORDER = exports.ADD_INACTIVE_ORDER = exports.ADD_ACCOUNT_TRADE = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _apiActions = require("./apiActions");
var _orderStateSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/orderStateSubscriptionService"));
var _orderTradesSuscriptionService = _interopRequireDefault(require("../../services/subscriptions/orderTradesSuscriptionService"));
var _marginCancelOrderLiquidationEventSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/marginCancelOrderLiquidationEventSubscriptionService"));
var _placeOrderHelper = require("../../helpers/placeOrderHelper");
var _orderEntryActions = require("./orderEntryActions");
var _snackbarActions = require("./snackbarActions");
var _paginationActions = require("./paginationActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ADD_OPEN_ORDER = exports.ADD_OPEN_ORDER = 'ADD_OPEN_ORDER';
var RECEIVE_OPEN_ORDERS = exports.RECEIVE_OPEN_ORDERS = 'RECEIVE_OPEN_ORDERS';
var REQUEST_OPEN_ORDERS = exports.REQUEST_OPEN_ORDERS = 'REQUEST_OPEN_ORDERS';
var RECEIVE_OPEN_ORDERS_NEXT_PAGE = exports.RECEIVE_OPEN_ORDERS_NEXT_PAGE = 'RECEIVE_OPEN_ORDERS_NEXT_PAGE';
var REQUEST_OPEN_ORDERS_NEXT_PAGE = exports.REQUEST_OPEN_ORDERS_NEXT_PAGE = 'REQUEST_OPEN_ORDERS_NEXT_PAGE';
var ADD_ACCOUNT_TRADE = exports.ADD_ACCOUNT_TRADE = 'ADD_ACCOUNT_TRADE';
var RECEIVE_ACCOUNT_TRADES = exports.RECEIVE_ACCOUNT_TRADES = 'RECEIVE_ACCOUNT_TRADES';
var REQUEST_ACCOUNT_TRADES = exports.REQUEST_ACCOUNT_TRADES = 'REQUEST_ACCOUNT_TRADES';
var RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = exports.RECEIVE_ACCOUNT_TRADES_NEXT_PAGE = 'RECEIVE_ACCOUNT_TRADES_NEXT_PAGE';
var REQUEST_ACCOUNT_TRADES_NEXT_PAGE = exports.REQUEST_ACCOUNT_TRADES_NEXT_PAGE = 'REQUEST_ACCOUNT_TRADES_NEXT_PAGE';
var ADD_INACTIVE_ORDER = exports.ADD_INACTIVE_ORDER = 'ADD_INACTIVE_ORDER';
var RECEIVE_INACTIVE_ORDERS = exports.RECEIVE_INACTIVE_ORDERS = 'RECEIVE_INACTIVE_ORDERS';
var REQUEST_INACTIVE_ORDERS = exports.REQUEST_INACTIVE_ORDERS = 'REQUEST_INACTIVE_ORDERS';
var RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = exports.RECEIVE_INACTIVE_ORDERS_NEXT_PAGE = 'RECEIVE_INACTIVE_ORDERS_NEXT_PAGE';
var REQUEST_INACTIVE_ORDERS_NEXT_PAGE = exports.REQUEST_INACTIVE_ORDERS_NEXT_PAGE = 'REQUEST_INACTIVE_ORDERS_NEXT_PAGE';
var RECEIVE_TRADE_REPORTS = exports.RECEIVE_TRADE_REPORTS = 'RECEIVE_TRADE_REPORTS';
var REQUEST_TRADE_REPORTS = exports.REQUEST_TRADE_REPORTS = 'REQUEST_TRADE_REPORTS';
var RECEIVE_TRADE_REPORTS_NEXT_PAGE = exports.RECEIVE_TRADE_REPORTS_NEXT_PAGE = 'RECEIVE_TRADE_REPORTS_NEXT_PAGE';
var REQUEST_TRADE_REPORTS_NEXT_PAGE = exports.REQUEST_TRADE_REPORTS_NEXT_PAGE = 'REQUEST_TRADE_REPORTS_NEXT_PAGE';
var RECEIVE_TRADE_HISTORY = exports.RECEIVE_TRADE_HISTORY = 'RECEIVE_TRADE_HISTORY';
var RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = exports.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID = 'RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID';
var REMOVE_ACTIVE_REQUEST = exports.REMOVE_ACTIVE_REQUEST = 'REMOVE_ACTIVE_REQUEST';
var REQUEST_RECENT_ACTIVITY = exports.REQUEST_RECENT_ACTIVITY = 'REQUEST_RECENT_ACTIVITY';
var RECEIVE_RECENT_ACTIVITY = exports.RECEIVE_RECENT_ACTIVITY = 'RECEIVE_RECENT_ACTIVITY';
var RECEIVE_INTEREST_ACCRUALS = exports.RECEIVE_INTEREST_ACCRUALS = 'RECEIVE_INTEREST_ACCRUALS';
var getOpenOrders = exports.getOpenOrders = function getOpenOrders(AccountId, OMSID, Limit, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var openOrdersCall, openOrders, openOrdersNextPage;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            openOrdersCall = function openOrdersCall(_ref2) {
              var index = _ref2.index;
              return dispatch((0, _apiActions.callAPI)('GetOpenOrders', {
                AccountId: AccountId,
                OMSID: OMSID,
                Limit: Limit,
                StartIndex: index
              }));
            };
            dispatch(requestOpenOrders({
              StartIndex: StartIndex
            }));
            dispatch(requestOpenOrdersNextPage());
            _context.n = 1;
            return openOrdersCall({
              index: StartIndex
            });
          case 1:
            openOrders = _context.v;
            _context.n = 2;
            return openOrdersCall({
              index: Limit + StartIndex
            });
          case 2:
            openOrdersNextPage = _context.v;
            dispatch(receiveOpenOrders(openOrders));
            dispatch(receiveOpenOrdersNextPage(openOrdersNextPage));
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var subscribeToOrderHistory = exports.subscribeToOrderHistory = function subscribeToOrderHistory() {
  return function (dispatch, getState) {
    _orderStateSubscriptionService["default"].subscribe(function (x) {
      if (['Working'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addOpenOrder(x));
        if (getState().form.buySell) {
          dispatch((0, _orderEntryActions.showBuySellSuccessMessage)());
        }
      } else if (['Rejected', 'Canceled', 'FullyExecuted', 'Expired'].some(function (i) {
        return x.OrderState === i;
      })) {
        dispatch(addInactiveOrder(x));
        if (getState().form.buySell) {
          if (x.OrderState === 'FullyExecuted') {
            dispatch((0, _orderEntryActions.showBuySellSuccessMessage)());
          } else {
            dispatch((0, _orderEntryActions.showBuySellFailMessage)());
          }
        }
      }
      if (x.CancelReason !== 'SystemCanceled_Liquidation' && x.CancelReason !== 'UserModified') {
        var snackBar = (0, _placeOrderHelper.getOrderEventSnackbar)(x);
        dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBar), {}, {
          id: snackBar.id || 'OrderStateEventSnackbar'
        })));
      }
    });
    _orderTradesSuscriptionService["default"].subscribe(function (x) {
      dispatch(addAccountTrade(x));
    });
  };
};
var subscribeToMarginCancelOrderLiquidationEvents = exports.subscribeToMarginCancelOrderLiquidationEvents = function subscribeToMarginCancelOrderLiquidationEvents() {
  return function (dispatch, getState) {
    _marginCancelOrderLiquidationEventSubscriptionService["default"].subscribe(function (x) {
      if (x.LiquidationEventType == 'CancelOrderEvent') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'MarginCancelOrderAccountLiquidation',
          text: 'Your {{InstrumentSymbol}} {{Side, lowercase}} {{OrderType}} order has been canceled due to account liquidation.',
          type: 'warning',
          textVars: _objectSpread(_objectSpread({}, x), {}, {
            ns: 'margin',
            InstrumentSymbol: getState().apexCore.instrument.instruments.find(function (i) {
              return i.InstrumentId === x.InstrumentId;
            }).Symbol
          })
        }));
      }
    });
  };
};
var getAccountTrades = exports.getAccountTrades = function getAccountTrades(AccountId, OMSId) {
  var Count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var StartIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var accountTradesCall, trades, tradesNextPage;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            accountTradesCall = function accountTradesCall(_ref4) {
              var index = _ref4.index;
              return dispatch((0, _apiActions.callAPI)('GetAccountTrades', {
                AccountId: AccountId,
                OMSId: OMSId,
                Count: Count,
                StartIndex: index
              }));
            };
            dispatch(requestAccountTrades({
              StartIndex: StartIndex
            }));
            dispatch(requestAccountTradesNextPage());
            _context2.n = 1;
            return accountTradesCall({
              index: StartIndex
            });
          case 1:
            trades = _context2.v;
            _context2.n = 2;
            return accountTradesCall({
              index: StartIndex + Count
            });
          case 2:
            tradesNextPage = _context2.v;
            dispatch(receiveAccountTrades(trades));
            dispatch(receiveAccountTradesNextPage(tradesNextPage));
            dispatch(receiveTradeHistory(trades));
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var resetActivePage = exports.resetActivePage = function resetActivePage(componentName) {
  return function (dispatch) {
    return dispatch((0, _paginationActions.setActivePage)({
      componentName: componentName,
      activePage: 0
    }));
  };
};
var requestRecentActivity = function requestRecentActivity(payload) {
  return {
    type: REQUEST_RECENT_ACTIVITY,
    payload: payload
  };
};
var receiveRecentActivity = function receiveRecentActivity(payload) {
  return {
    type: RECEIVE_RECENT_ACTIVITY,
    payload: payload
  };
};
var receiveInterestAccruals = function receiveInterestAccruals(payload) {
  return {
    type: RECEIVE_INTEREST_ACCRUALS,
    payload: payload
  };
};
var getRecentActivity = exports.getRecentActivity = function getRecentActivity() {
  var Depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
  var StartIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ProductId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var _getState$user, AccountId, userInfo, accounts, OMSId, TransactionReferenceTypes, filterState, StartTimestamp, StartDate, EndTimestamp, EndDate, selectedAccount, isMarginAccount, TransactionTypes, apiCalls, results, trades, interestAccruals;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _getState$user = getState().user, AccountId = _getState$user.selectedAccountId, userInfo = _getState$user.userInfo, accounts = _getState$user.accounts;
            OMSId = userInfo.OMSId;
            dispatch(requestRecentActivity({
              StartIndex: StartIndex
            }));
            TransactionReferenceTypes = ['1', '2', '3'];
            filterState = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'type'], 'all');
            if (filterState !== 'all') {
              if (filterState === 'trades') {
                TransactionReferenceTypes = ['1'];
              }
              if (filterState === 'withdraw') {
                TransactionReferenceTypes = ['3'];
              }
              if (filterState === 'deposit') {
                TransactionReferenceTypes = ['2'];
              }
            }
            StartDate = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'startDate']);
            if (StartDate && typeof StartDate !== 'string') {
              StartTimestamp = StartDate.getTime();
            }
            EndDate = (0, _get["default"])(getState(), ['form', 'recent-activity', 'values', 'endDate']);
            if (EndDate && typeof EndDate !== 'string') {
              EndTimestamp = EndDate.getTime();
            }

            // Check if the selected account is a margin account
            selectedAccount = accounts.find(function (account) {
              return account.AccountId === AccountId;
            });
            isMarginAccount = (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.AccountType) === 'Margin';
            TransactionTypes = [];
            if (isMarginAccount) {
              // Include liquidate fee transactions for margin accounts
              TransactionTypes.push('33');
            }

            // Fetch transactions and optionally interest accruals (only for margin accounts)
            apiCalls = [dispatch((0, _apiActions.callAPI)('GetAccountTransactions', {
              AccountId: AccountId,
              OMSId: OMSId,
              Depth: Depth,
              StartIndex: StartIndex,
              ProductId: ProductId,
              TransactionReferenceTypes: TransactionReferenceTypes,
              TransactionTypes: TransactionTypes,
              StartTimestamp: StartTimestamp,
              EndTimestamp: EndTimestamp
            }))];
            if (isMarginAccount) {
              apiCalls.push(dispatch((0, _apiActions.callAPI)('GetAccountMarginPositionInterestAccruals', {
                startIndex: StartIndex,
                depth: Depth,
                omsId: OMSId,
                accountId: AccountId
              })));
            }
            _context3.n = 1;
            return Promise.all(apiCalls);
          case 1:
            results = _context3.v;
            trades = results[0];
            interestAccruals = results[1] || [];
            dispatch(receiveRecentActivity({
              data: trades
            }));
            dispatch(receiveInterestAccruals({
              data: interestAccruals
            }));
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var FetchAccountTradesForOrderId = exports.FetchAccountTradesForOrderId = function FetchAccountTradesForOrderId(OrderId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var _getState, user, AccountId, trades;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _getState = getState(), user = _getState.user;
            AccountId = user.accounts[0].AccountId;
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetAccountTrades', {
              AccountId: AccountId,
              OrderId: OrderId,
              OMSID: 1
            }));
          case 1:
            trades = _context4.v;
            dispatch(receiveAccountTradesForOrderId(trades));
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var getInactiveOrders = exports.getInactiveOrders = function getInactiveOrders(AccountId, OMSId, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch) {
      var orderHistoryCall, orders;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            orderHistoryCall = function orderHistoryCall(_ref8) {
              var index = _ref8.index;
              return dispatch((0, _apiActions.callAPI)('GetOrderHistory', {
                AccountId: AccountId,
                OMSId: OMSId,
                StartIndex: index
              }));
            };
            dispatch(requestInactiveOrders({
              StartIndex: StartIndex
            }));
            _context5.n = 1;
            return orderHistoryCall({
              index: StartIndex
            });
          case 1:
            orders = _context5.v;
            dispatch(receiveInactiveOrders(orders));
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var getOrders = exports.getOrders = function getOrders(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var Depth, orders;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            dispatch(requestInactiveOrders({}));
            Depth = 1000;
            _context6.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetOrders', {
              AccountId: AccountId,
              OMSId: OMSId,
              Depth: Depth
            }));
          case 1:
            orders = _context6.v;
            dispatch(receiveInactiveOrders(orders));
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function (_x8) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var removeActiveRequest = exports.removeActiveRequest = function removeActiveRequest() {
  return {
    type: REMOVE_ACTIVE_REQUEST
  };
};
var getOpenTradeReports = exports.getOpenTradeReports = function getOpenTradeReports(AccountId, OMSId, StartIndex) {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch) {
      var tradeReportsCall, tradeReports;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            tradeReportsCall = function tradeReportsCall(_ref1) {
              var StartIndex = _ref1.StartIndex;
              return dispatch((0, _apiActions.callAPI)('GetOpenTradeReports', {
                AccountId: AccountId,
                OMSId: OMSId,
                StartIndex: StartIndex
              }));
            };
            dispatch(requestTradeReports({
              StartIndex: StartIndex
            }));
            _context7.n = 1;
            return tradeReportsCall({
              StartIndex: StartIndex
            });
          case 1:
            tradeReports = _context7.v;
            dispatch(receiveTradeReports(tradeReports));
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x9) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var receiveOpenOrders = exports.receiveOpenOrders = function receiveOpenOrders(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS,
    payload: payload
  };
};
var requestOpenOrders = exports.requestOpenOrders = function requestOpenOrders(payload) {
  return {
    type: REQUEST_OPEN_ORDERS,
    payload: payload
  };
};
var receiveOpenOrdersNextPage = exports.receiveOpenOrdersNextPage = function receiveOpenOrdersNextPage(payload) {
  return {
    type: RECEIVE_OPEN_ORDERS_NEXT_PAGE,
    payload: payload
  };
};
var requestOpenOrdersNextPage = exports.requestOpenOrdersNextPage = function requestOpenOrdersNextPage(payload) {
  return {
    type: REQUEST_OPEN_ORDERS_NEXT_PAGE,
    payload: payload
  };
};
var addOpenOrder = exports.addOpenOrder = function addOpenOrder(payload) {
  return {
    type: ADD_OPEN_ORDER,
    payload: payload
  };
};
var addInactiveOrder = exports.addInactiveOrder = function addInactiveOrder(payload) {
  return {
    type: ADD_INACTIVE_ORDER,
    payload: payload
  };
};
var receiveAccountTrades = exports.receiveAccountTrades = function receiveAccountTrades(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES,
    payload: payload
  };
};
var receiveAccountTradesNextPage = exports.receiveAccountTradesNextPage = function receiveAccountTradesNextPage(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_NEXT_PAGE,
    payload: payload
  };
};
var receiveAccountTradesForOrderId = exports.receiveAccountTradesForOrderId = function receiveAccountTradesForOrderId(payload) {
  return {
    type: RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID,
    payload: payload
  };
};
var requestAccountTrades = exports.requestAccountTrades = function requestAccountTrades(payload) {
  return {
    type: REQUEST_ACCOUNT_TRADES,
    payload: payload
  };
};
var requestAccountTradesNextPage = exports.requestAccountTradesNextPage = function requestAccountTradesNextPage(payload) {
  return {
    type: REQUEST_ACCOUNT_TRADES_NEXT_PAGE,
    payload: payload
  };
};
var addAccountTrade = exports.addAccountTrade = function addAccountTrade(payload) {
  return {
    type: ADD_ACCOUNT_TRADE,
    payload: payload
  };
};
var receiveInactiveOrders = exports.receiveInactiveOrders = function receiveInactiveOrders(payload) {
  return {
    type: RECEIVE_INACTIVE_ORDERS,
    payload: payload
  };
};
var requestInactiveOrders = exports.requestInactiveOrders = function requestInactiveOrders(payload) {
  return {
    type: REQUEST_INACTIVE_ORDERS,
    payload: payload
  };
};
var receiveTradeReports = exports.receiveTradeReports = function receiveTradeReports(payload) {
  return {
    type: RECEIVE_TRADE_REPORTS,
    payload: payload
  };
};
var requestTradeReports = exports.requestTradeReports = function requestTradeReports(payload) {
  return {
    type: REQUEST_TRADE_REPORTS,
    payload: payload
  };
};
var receiveTradeHistory = exports.receiveTradeHistory = function receiveTradeHistory(payload) {
  return {
    type: RECEIVE_TRADE_HISTORY,
    payload: payload
  };
};
var cancelAllOrders = exports.cancelAllOrders = function cancelAllOrders() {
  return function (dispatch, getState) {
    var OMSId = getState().user.userInfo.OMSId;
    var selectedAccountId = getState().user.selectedAccountId;
    var selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
    dispatch((0, _apiActions.callAPI)('CancelAllOrders', {
      OMSId: OMSId,
      AccountId: selectedAccountId,
      InstrumentId: selectedInstrumentId
    })).then(function () {
      return dispatch((0, _snackbarActions.showSnack)({
        id: 'cancelAllOrdersSuccessSnack',
        text: "All orders cancelled",
        type: 'success'
      }));
    });
  };
};
var cancelSellOrders = exports.cancelSellOrders = function cancelSellOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Sell');
  };
};
var cancelBuyOrders = exports.cancelBuyOrders = function cancelBuyOrders() {
  return function (dispatch, getState) {
    cancelSideOrders(dispatch, getState, 'Buy');
  };
};
var cancelOrders = exports.cancelOrders = function cancelOrders(OrderIds) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dispatch, getState) {
      var OMSId, selectedAccountId, cancelOrderPromises;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            selectedAccountId = getState().user.selectedAccountId;
            if (!(OrderIds.length > 1)) {
              _context8.n = 4;
              break;
            }
            cancelOrderPromises = OrderIds.map(function (orderId) {
              dispatch((0, _apiActions.callAPI)('CancelOrder', {
                OrderId: orderId,
                AccountId: selectedAccountId,
                OMSId: OMSId
              }));
            });
            _context8.n = 1;
            return Promise.all(cancelOrderPromises);
          case 1:
            _context8.n = 2;
            return dispatch(getOpenOrders(selectedAccountId, OMSId));
          case 2:
            _context8.n = 3;
            return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
          case 3:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelOrderSuccessSnack',
              // t('Orders {{n}} cancelled')
              text: "Orders {{n}} cancelled",
              textVars: {
                n: OrderIds.toString()
              },
              type: 'success'
            }));
            _context8.n = 8;
            break;
          case 4:
            _context8.n = 5;
            return dispatch((0, _apiActions.callAPI)('CancelOrder', {
              OrderId: OrderIds[0],
              AccountId: selectedAccountId,
              OMSId: OMSId
            }));
          case 5:
            _context8.n = 6;
            return dispatch(getOpenOrders(selectedAccountId, OMSId));
          case 6:
            _context8.n = 7;
            return dispatch(getOpenTradeReports(selectedAccountId, OMSId));
          case 7:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelOrderSuccessSnack',
              // t('Order {{n}} cancelled')
              text: "Order {{n}} cancelled",
              textVars: {
                n: OrderIds[0]
              },
              type: 'success'
            }));
          case 8:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return function (_x0, _x1) {
      return _ref10.apply(this, arguments);
    };
  }();
};
function cancelSideOrders(dispatch, getState, side) {
  var openOrders = getState().apexCore.orderHistory.openOrders;
  var OMSId = getState().user.userInfo.OMSId;
  var selectedAccountId = getState().user.selectedAccountId;
  var sideOrderIds = openOrders.filter(function (order) {
    return order.Side === side;
  }).map(function (order) {
    return order.OrderId;
  });
  sideOrderIds.forEach(function (OrderId) {
    dispatch((0, _apiActions.callAPI)('CancelOrder', {
      OrderId: OrderId,
      AccountId: selectedAccountId,
      OMSId: OMSId
    }));
  });
  if (side === 'Buy') {
    dispatch((0, _snackbarActions.showSnack)({
      id: 'cancelBuyOrdersSuccessSnack',
      text: "Buy orders cancelled",
      type: 'success'
    }));
  } else {
    dispatch((0, _snackbarActions.showSnack)({
      id: 'cancelSellOrdersSuccessSnack',
      text: "Sell orders cancelled",
      type: 'success'
    }));
  }
}